module.exports = __webpack_public_path__ + "images/emoji/new_moon.9a04a8cd98fa2a95f7a0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/new_moon.png
// module id = l6m4
// module chunks = 14